import React from 'react';
import { Row } from 'antd';
import FileItemRender from './children/FileItemRender';

const FileListModalRender = ({
  files,
  handleSelectClick,
  handleDelete,
  handleDownloadClick,
  selectGuidList,
  isEditing,
  setMediaInfo,
  activeType,
  activeSubType,
  handleMultipleSelect,
}) => {
  return (
    <div>
      <div className='Files'>
        <Row gutter={[16, 16]} justify='flex-start' align='middle'>
          {files.length > 0
            ? files
                .sort((a, b) => {
                  if (a.created_at === 0 && b.created_at === 0) {
                    return 0;
                  }
                  if (a.created_at === 0) {
                    return activeSubType === 0 ? 1 : -1;
                  }
                  if (b.created_at === 0) {
                    return activeSubType === 0 ? -1 : 1;
                  }

                  return activeSubType === 0
                    ? b.created_at - a.created_at
                    : a.created_at - b.created_at;
                })
                .map((item, index) => {
                  if (activeType === 'All') {
                    return (
                      <FileItemRender
                        handleSelectClick={handleSelectClick}
                        handleDelete={handleDelete}
                        handleDownloadClick={handleDownloadClick}
                        selectGuidList={selectGuidList}
                        index={index}
                        key={index}
                        file={item}
                        isEditing={isEditing}
                        setMediaInfo={setMediaInfo}
                        handleMultipleSelect={handleMultipleSelect}
                      />
                    );
                  } else if (activeType !== 'All') {
                    if (activeType === item.media_type) {
                      return (
                        <FileItemRender
                          handleSelectClick={handleSelectClick}
                          handleDelete={handleDelete}
                          handleDownloadClick={handleDownloadClick}
                          selectGuidList={selectGuidList}
                          index={index}
                          key={index}
                          file={item}
                          isEditing={isEditing}
                          setMediaInfo={setMediaInfo}
                          handleMultipleSelect={handleMultipleSelect}
                        />
                      );
                    }
                  }
                })
            : null}
        </Row>
      </div>
    </div>
  );
};

export default FileListModalRender;
